import { Navigate, Route, Routes } from "react-router-dom";

import LayoutOutlet from "../layouts/layoutOutlet";

import LandingPage from "../pages/landingPage";

import AboutPage from "../pages/about";
import PlatformPage from "../pages/platform";
import BlogPage from "../pages/blog";
import BlogDetailsPage from "../pages/blogDetails";
import ContactPage from "../pages/contact";

import PrivacyPolicyPage from "../pages/privacyPolicyPage";
import TermsNConditionsPage from "../pages/termsNConditionsPage";

import NotFoundPage from "../pages/notFoundPage";

import PlatformData from '../data/platforms/platform-list.json';

const Router = () => {
    return(
        <Routes>
            <Route path="/" element={<LayoutOutlet />}>
                <Route index element={<LandingPage />} />

                <Route path="about" element={<AboutPage />} />
                <Route path="platform" element={<Navigate to={`/platform/${PlatformData.en[0].file}`} replace />} />
                <Route path="platform/:id" element={<PlatformPage />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="blog/:id" element={<BlogDetailsPage />} />
                <Route path="contact" element={<ContactPage />} />

                <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="terms-and-conditions" element={<TermsNConditionsPage />} />

                <Route path="*" element={<NotFoundPage />} />
            </Route>
        </Routes>
    );
}

export default Router;